export const Roles = {
  USER: "USER",
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPERADMIN",
  /** Makes Klaviyo drafts in Klip; given by the ClickUp sync */
  IMPLEMENTATOR: "IMPLEMENTATOR",
  /** Sees Klip */
  CAMPAIGN_MANAGER: "CAMPAIGN_MANAGER",
  /** Makes Klips on every account, from the open tasks whose copy has one image; given by an admin */
  OKTO: "OKTO",
} as const;

export type RoleName = (typeof Roles)[keyof typeof Roles];

/** i18n key mapping for role display names */
export const ROLE_I18N_KEYS: Record<RoleName, string> = {
  [Roles.USER]: "users.role.USER",
  [Roles.ADMIN]: "users.role.ADMIN",
  [Roles.SUPERADMIN]: "users.role.SUPERADMIN",
  [Roles.IMPLEMENTATOR]: "users.role.IMPLEMENTATOR",
  [Roles.CAMPAIGN_MANAGER]: "users.role.CAMPAIGN_MANAGER",
  [Roles.OKTO]: "users.role.OKTO",
};

/** Klip's roles. Alone (without USER or ADMIN) they keep a person inside Klip. */
export const KLIP_ROLES: RoleName[] = [Roles.IMPLEMENTATOR, Roles.CAMPAIGN_MANAGER, Roles.OKTO];

/** Roles shown in the create/edit user role picker */
export const ASSIGNABLE_ROLES: RoleName[] = [Roles.USER, Roles.ADMIN, Roles.OKTO];

/** Roles that can access admin pages (users, activity history) */
export const ADMIN_PAGE_ROLES: RoleName[] = [Roles.ADMIN, Roles.SUPERADMIN];

/** Default role for new admin-created users */
export const DEFAULT_NEW_USER_ROLE: RoleName = Roles.USER;
